import { createRouter, createWebHistory } from "vue-router";
import routes from "vue-auto-routing";
import { createRouterLayout } from "vue-router-layout";

const RouterLayout = createRouterLayout((layout) => {
  return import("@/layouts/" + layout + ".vue");
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "/",
      component: RouterLayout,
      children: routes,
    },
  ],
});

router.beforeEach((_, __, next) => {
  next();

  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
});

export default router;
